import { EnumOption } from "./enum-option"

export const FNEducation = {
    None: 0,
    SomeCollegeCreditLessThanOneYear: 1,
    OneOrMoreYearsCollegeNoDegree: 2,
    HighSchool: 3,
    Associates: 4,
    Bachelors: 5,
    Masters: 6,
    Doctorate: 7,
    Professional: 8,
    Other: 9,
}

export const FNEducationList: EnumOption[] = [
    { value: FNEducation.None, label: 'None' },
    { value: FNEducation.SomeCollegeCreditLessThanOneYear, label: 'Some college credit, but less than one year' },
    { value: FNEducation.OneOrMoreYearsCollegeNoDegree, label: 'One or more years of college, no degree' },
    { value: FNEducation.HighSchool, label: 'High School/GED' },
    { value: FNEducation.Associates, label: 'Associate\'s' },
    { value: FNEducation.Bachelors, label: 'Bachelor\'s' },
    { value: FNEducation.Masters, label: 'Master\'s' },
    { value: FNEducation.Doctorate, label: 'Doctorate (PhD, EdD)' },
    { value: FNEducation.Professional, label: 'Professional Degree' },
    { value: FNEducation.Other, label: 'Other Degree' },
]
